import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import components from './components';
import idcCommon from 'idc-common';
// import ElementUI from 'element-ui';
import 'idc-common/lib/idc-common.css';
import '@assets/sass/index.scss';
import 'nprogress/nprogress.css';
import http from './http';
import serviceAPI from './http/service/index.js';
import echarts from 'echarts';
import dict from './util/dict';
import { Encrypt, Decrypt, Debounce } from './util/utils';
// import treeTransfer from 'el-tree-transfer'; // 引入

Vue.use(http);

Vue.prototype.$service = serviceAPI;
Vue.prototype.$echarts = echarts;
Vue.prototype.$Debounce = Debounce; // 防抖函数
Vue.prototype.$Dict = dict; // 防抖函数

Vue.use(idcCommon);
// Vue.use(ElementUI);
Vue.use(components);
// Vue.use(treeTransfer);

Vue.config.productionTip = false;
const vue = new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app');
export default vue;
